export type OrderStatusStyle = {
  label: string;
  className: string;
  compactClassName: string;
  icon: string;
};

export const ORDER_TABS = [
  { key: 'all', label: '全部' },
  { key: 'pending', label: '待处理' },
  { key: 'processing', label: '处理中' },
  { key: 'completed', label: '已完成' },
  { key: 'failed', label: '失败' },
] as const;

export type OrderTabKey = (typeof ORDER_TABS)[number]['key'];

export const ORDER_TAB_STATUS_MAP: Record<Exclude<OrderTabKey, 'all'>, string[]> = {
  pending: ['PENDING', 'CREATED'],
  processing: ['PROCESSING', 'FEEDBACK'],
  completed: ['COMPLETED'],
  failed: ['FAILED', 'REFUNDED'],
};

const ORDER_STATUS_STYLES: Record<string, OrderStatusStyle> = {
  PENDING: {
    label: '待处理',
    className: 'bg-amber-50 text-amber-600 border border-amber-200',
    compactClassName: 'bg-amber-50 text-amber-600',
    icon: 'ri-time-line',
  },
  CREATED: {
    label: '待处理',
    className: 'bg-amber-50 text-amber-600 border border-amber-200',
    compactClassName: 'bg-amber-50 text-amber-600',
    icon: 'ri-time-line',
  },
  PROCESSING: {
    label: '处理中',
    className: 'bg-blue-50 text-blue-600 border border-blue-200',
    compactClassName: 'bg-blue-50 text-blue-600',
    icon: 'ri-loader-4-line',
  },
  FEEDBACK: {
    label: '已反馈',
    className: 'bg-blue-50 text-blue-600 border border-blue-200',
    compactClassName: 'bg-blue-50 text-blue-600',
    icon: 'ri-message-2-line',
  },
  COMPLETED: {
    label: '已完成',
    className: 'bg-emerald-50 text-emerald-600 border border-emerald-200',
    compactClassName: 'bg-emerald-50 text-emerald-600',
    icon: 'ri-checkbox-circle-line',
  },
  FAILED: {
    label: '失败',
    className: 'bg-rose-50 text-rose-600 border border-rose-200',
    compactClassName: 'bg-rose-50 text-rose-500',
    icon: 'ri-close-circle-line',
  },
  REFUNDED: {
    label: '已退款',
    className: 'bg-gray-100 text-gray-500 border border-gray-200',
    compactClassName: 'bg-gray-100 text-gray-500',
    icon: 'ri-refund-line',
  },
};

const FALLBACK_STATUS: OrderStatusStyle = {
  label: '',
  className: 'bg-gray-100 text-gray-600 border border-gray-200',
  compactClassName: 'bg-gray-100 text-gray-500',
  icon: 'ri-question-line',
};

export function getOrderStatusStyle(status: string): OrderStatusStyle {
  const st = ORDER_STATUS_STYLES[status];
  if (st) {
    return st;
  }
  return { ...FALLBACK_STATUS, label: status || '未知' };
}

export function orderMatchesTab(status: string, tab: OrderTabKey): boolean {
  if (tab === 'all') {
    return true;
  }
  return ORDER_TAB_STATUS_MAP[tab].includes(status);
}

export function isApiOrderWithResult(order: { productType?: string; status: string }): boolean {
  return (
    order.productType === 'API' &&
    (order.status === 'COMPLETED' || order.status === 'FAILED')
  );
}

export function isP2pOrderWithResult(order: { productType?: string; status: string }): boolean {
  return (
    order.productType !== 'API' &&
    (order.status === 'FEEDBACK' || order.status === 'COMPLETED')
  );
}

export function isP2pOrderWithContact(order: { productType?: string; status: string }): boolean {
  return (
    order.productType !== 'API' &&
    (order.status === 'PROCESSING' ||
      order.status === 'FEEDBACK' ||
      order.status === 'COMPLETED')
  );
}
